import { useMutation } from 'react-query';
import editRoomDescription from '../requests/editRoomDescription';

const useEditRoomDescriptionMutation = (options) =>
  useMutation(
    ({ description, room }) => editRoomDescription(description, room),
    options
  );

export default useEditRoomDescriptionMutation;
